import React, { Component } from 'react';
import { loginService } from '../../services/login.service';
import Loader from '../../_helpers/Loader';
import { historypush } from '../../_helpers/utilities';
import eye from "../../Images/eye.png";
import { helperText } from '../../_helpers/helpertext';
import { isStringEmpty } from '../../_helpers/string_helper';

// function withParams(Component) {
//   return props => <Component {...props} params={useParams()} />;
// }

class ChangePassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            password: "",
            confirmPassword: "",
            isLoading: false,
            guidtoSend:"",
            errorMessage:"",
            showPassword: false,
            showConfirmPassword: false,
        };
    }

    componentDidMount = async() => {
        var str = window.location.pathname;
        str=str.split("/");
        var result=str[str.length-2];
        this.setState({
            guidtoSend:result,
            isLoading : true,
        })
        var response = await loginService.CheckIfPasswordChangeLinkValid(result);
        if(response.status === 200){
            if(response.data === false){
                //redirect
                historypush("/errorPage")
            }else{
                this.setState({isLoading : false});
            }
        }else{
            this.setState({isLoading : false});
        }
    };
    
    changePasswordValue = (e) => {
        const { name, value } = e.target;
        this.setState({
          [name]: value,
        });
    };

    toggleEye = () => {
        const currentState = this.state.showPassword;
        this.setState({ showPassword: !currentState });
    };

    toggleConfirmEye = () => {
        const currentState = this.state.showConfirmPassword;
        this.setState({ showConfirmPassword: !currentState });
    };

    validate=()=>{
        const{
            password,
            confirmPassword,
        }=this.state;

        var format = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;
        
        if(isStringEmpty(password)){
            this.setState({
              errorMessage: helperText.resetPageText.emptyPassword,
            })
            return
        }
        if(password === confirmPassword){
            if(format.test(password)){
                if (password.length > 7) {
                    this.updatePassword();
                } else {
                    this.setState({
                      errorMessage: helperText.resetPageText.passwordLength,
                    });
                }
            }else{
                this.setState({
                    errorMessage: helperText.resetPageText.specialCharacterMissing,
                })
            }
        }else{
            this.setState({
                errorMessage: helperText.resetPageText.unMatchPassword,
            });
        }
    }

    updatePassword=async()=>{
        try{
            this.setState({ isLoading:true, })

            const{guidtoSend,password}=this.state;
            var response = await loginService.updatePassword(guidtoSend,password);
            if (response.status === 200) {
                if(response.data === 'true'){
                    this.setState({
                        errorMessage: helperText.resetPageText.passwordUpdateSuccess,
                    });
                // }else{
                // this.setState({
                //     popUpModalText: helperText.resetPageText.urlAlreadyUsed,
                //     showPopupModal: true,
                //     messageType:MessageType.Failure,
                // });
                }

                historypush('/login');
      }
            
            this.setState({ isLoading:false, })
        }
        catch(e){
            return "";
        }
    }
    render() {
        const{
            isLoading,
            password,
            confirmPassword,
            showPassword,
            showConfirmPassword,
            errorMessage,
        }=this.state;
        return (
            <div className="container">
                {isLoading && <Loader />}
                <div className="Login-form" style={{marginTop: '30px'}}>
                    <h2 style={{color: 'black'}}>Change Password</h2>
                    <p style={{padding: '15px 0px', color: '#8A8A8A', fontSize: '15px'}}>Min. 8 characters containing at least 1 special character.</p>
                    <label htmlFor="pwd" style={{marginBottom: '7px', color: '#7a7a7a', fontSize: '20px'}}>New Password:</label>
                    <input 
                        type={showPassword ? "text" : "password"}
                        className="form-control" 
                        id="pwd" 
                        value={password}
                        name="password"
                        onChange={(e) => this.changePasswordValue(e)}
                        placeholder="Enter your new password" 
                        style={{color: '#9E9E9E', fontSize: '17px', height: '50px'}} 
                    />
                    <img
                        style={{ marginLeft: "90%", marginTop: "-117px",cursor :'pointer' }}
                        src={eye}
                        onClick={this.toggleEye}
                        alt="Eye"
                    />
                    <br />
                    <label htmlFor="pwd" style={{marginBottom: '7px', color: '#7a7a7a', fontSize: '20px'}}>Confirm New Password:</label>
                    <input 
                        type={showConfirmPassword ? "text" : "password"}
                        className="form-control" 
                        id="pwd" 
                        name="confirmPassword"
                        value={confirmPassword}
                        onChange={(e) => this.changePasswordValue(e)}
                        placeholder="Enter your confirm password" 
                        style={{color: '#9E9E9E', fontSize: '17px', height: '50px'}} 
                    />
                    <img
                        style={{ marginLeft: "90%", marginTop: "-117px",cursor :'pointer' }}
                        src={eye}
                        onClick={this.toggleConfirmEye}
                        alt="Eye"
                    />
                    <br />
                    <div style={{paddingLeft:"13px",marginTop:'-5px',color:'red'}}>{errorMessage}</div>
                    <div className="registerbutton d-grid" id="my_form">
                    <input 
                        className="Login-btn" 
                        type="submit" 
                        defaultValue="SAVE" 
                        onClick={()=>{this.validate()}}
                        style={{padding: '7px 0px', marginRight: '0px', backgroundColor: '#4B7BB0', fontWeight: 700}} 
                    />
                    </div>
                </div>
            </div>
        );
    }
}

export default ChangePassword;